//@ts-nocheck

import { GeoArrowScatterplotLayer } from '@geoarrow/deck.gl-layers';
import { Table } from 'apache-arrow';

export function createGeoArrowScatterplotLayer(table: Table | null, id: string, visibleOverride?: boolean) {
  if (!table || table.numRows === 0) return null;
  const geometryColumn = table.getChild('geometry');
  const colorColumn = table.getChild('binary_color');
  const visible = visibleOverride ?? true;
  const gaspl = new GeoArrowScatterplotLayer({
    id: `${id}`,
    data: table,
    getPosition: geometryColumn,
    getFillColor: colorColumn,
    getRadius: 2,
    radiusMaxPixels: 5,
    radiusMinPixels: 1,
    pickable: false,
    visible,
    highPrecision: false,
    // getTooltip: ({ object }) => {
    //   if (!object) return null;
    //   // Extract fields for tooltip (adjust based on your Table schema)
    //   const sicLetter = object.getChild('sic_letter')?.get(0) || 'Unknown';
    //   const companyName = object.getChild('company_name')?.get(0) || 'N/A'; // Example field
    //   return {
    //     html: `
    //       <div style="background: rgba(0, 0, 0, 0.8); color: white; padding: 8px; border-radius: 4px;">
    //         <b>SIC Letter:</b> ${sicLetter}<br/>
    //         <b>Company:</b> ${companyName}
    //       </div>
    //     `,
    //   };
    //},
  });
  return gaspl;
}